import { IFormConfigurationContext } from '@wyz/types';
import { UseQueryResult } from '@wyz/utils';
import { createContext } from 'react';
import {
  ISupplierTypeOptionItem,
  ITyreCountOptionItem,
  IVehicleTypeGroupList,
  IVehicleTypeGroupsOptionItem,
} from '~/common/types';
import { IPurchaseErrorResponse } from '~/purchase/types';

export type IFormContext = {
  mode: IFormConfigurationContext['mode'];
  vehicleTypeGroups: {
    optionItems: Array<IVehicleTypeGroupsOptionItem>;
  } & UseQueryResult<IVehicleTypeGroupList, IPurchaseErrorResponse>;
  tyreCounts: { optionItems: Array<ITyreCountOptionItem> };
  supplierTypes: { optionItems: Array<ISupplierTypeOptionItem> };
};
export const FormContext = createContext<IFormContext | undefined>(undefined);
